import type { GridState } from "./grid-utils";

/** The grid-store fields that make up the routine; paging and drag state are left out. */
export type RoutineFields = {
  cells: GridState;
  granularity: number;
  slotsPerDay: number;
  numDays: number;
  startDate: string;
};

export function changesRoutine(next: RoutineFields, prev: RoutineFields): boolean {
  return (
    next.cells !== prev.cells ||
    next.granularity !== prev.granularity ||
    next.slotsPerDay !== prev.slotsPerDay ||
    next.numDays !== prev.numDays ||
    next.startDate !== prev.startDate
  );
}
